import { render } from "./vipCardAdd.vue?vue&type=template&id=27edbba7&scoped=true&ts=true"
import script from "./vipCardAdd.vue?vue&type=script&lang=ts"
export * from "./vipCardAdd.vue?vue&type=script&lang=ts"

import "./vipCardAdd.vue?vue&type=style&index=0&id=27edbba7&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27edbba7"]])

export default __exports__